import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import { ClientAuthProvider } from "@/context/ClientAuthContext";
import { ContentProvider } from "@/context/ContentContext";
import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import BlogListPage from "@/pages/BlogListPage";
import BlogPostPage from "@/pages/BlogPostPage";
import DocumentsPage from "@/pages/DocumentsPage";
import AppointmentManagePage from "@/pages/AppointmentManagePage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import ClientLoginPage from "@/pages/ClientLoginPage";
import ClientSignupPage from "@/pages/ClientSignupPage";
import ClientForgotPasswordPage from "@/pages/ClientForgotPasswordPage";
import ClientResetPasswordPage from "@/pages/ClientResetPasswordPage";
import ClientPortalPage from "@/pages/ClientPortalPage";
import AdPromoPage from "@/pages/AdPromoPage";
import ScrollProgressBar from "@/components/ScrollProgressBar";
import BackToTop from "@/components/BackToTop";
import AnalyticsTracker from "@/components/AnalyticsTracker";
import ConditionalChatWidget from "@/components/ConditionalChatWidget";

const TOAST_OPTIONS = {
  style: {
    background: "#131315",
    border: "1px solid rgba(244,196,48,0.3)",
    color: "#f5f5f5",
  },
};

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <LanguageProvider>
          <AuthProvider>
            <ClientAuthProvider>
              <ContentProvider>
                <ScrollProgressBar />
                <AnalyticsTracker />
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/services" element={<ServicesPage />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/blog" element={<BlogListPage />} />
                  <Route path="/blog/:slug" element={<BlogPostPage />} />
                  <Route path="/documents" element={<DocumentsPage />} />
                  <Route path="/appointments/manage/:token" element={<AppointmentManagePage />} />
                  <Route path="/admin/login" element={<AdminLoginPage />} />
                  <Route path="/admin" element={<AdminDashboardPage />} />
                  <Route path="/portal/login" element={<ClientLoginPage />} />
                  <Route path="/portal/signup" element={<ClientSignupPage />} />
                  <Route path="/portal/forgot-password" element={<ClientForgotPasswordPage />} />
                  <Route path="/portal/reset-password/:token" element={<ClientResetPasswordPage />} />
                  <Route path="/portal" element={<ClientPortalPage />} />
                  <Route path="/apply" element={<AdPromoPage />} />
                </Routes>
                <BackToTop />
                <ConditionalChatWidget />
                <Toaster theme="dark" position="top-right" toastOptions={TOAST_OPTIONS} />
              </ContentProvider>
            </ClientAuthProvider>
          </AuthProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
